import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import LegalPageLayout from '../components/LegalPageLayout';

const CookiePolicy: React.FC = () => {
  useEffect(() => {
    document.title = 'Cookie Policy — Buy Drop';
  }, []);

  return (
    <LegalPageLayout title="Cookie Policy">
      <p className="text-sm leading-relaxed mb-6">
        This Cookie Policy explains how Buy Drop (&quot;we,&quot; &quot;us,&quot; or &quot;our&quot;) uses cookies and
        similar technologies on our websites and web views, and how you can control them. For how we use personal data
        more broadly, see our{' '}
        <Link to="/privacy" className="text-green-700 font-medium hover:underline">
          Privacy Policy
        </Link>
        .
      </p>

      <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3">1. What are cookies?</h2>
      <p className="text-sm leading-relaxed mb-4">
        Cookies are small text files stored on your device when you visit a site. They help the site remember your
        preferences, keep you signed in, and understand how the site is used. We also use similar technologies such as
        local storage and pixels where applicable.
      </p>

      <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3">2. How we use cookies</h2>
      <ul className="list-disc pl-5 text-sm leading-relaxed space-y-2 mb-4">
        <li>
          <strong className="text-gray-900">Essential:</strong> required for security, load balancing, authentication,
          and core shopping features (e.g. cart, checkout).
        </li>
        <li>
          <strong className="text-gray-900">Preferences:</strong> remember settings such as language or display
          choices.
        </li>
        <li>
          <strong className="text-gray-900">Analytics:</strong> help us measure traffic and improve the product (may
          be first- or third-party).
        </li>
        <li>
          <strong className="text-gray-900">Marketing:</strong> where used, to deliver or measure ads on our behalf
          (subject to your choices and applicable law).
        </li>
      </ul>

      <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3">3. Third parties</h2>
      <p className="text-sm leading-relaxed mb-4">
        Partners such as analytics or payment providers may set their own cookies when you use embedded content or
        checkout flows. Their use is governed by their respective policies.
      </p>

      <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3">4. Your choices</h2>
      <p className="text-sm leading-relaxed mb-4">
        Most browsers let you block or delete cookies through settings. Blocking essential cookies may break parts of
        the Services (e.g. staying signed in or completing checkout). You can also use industry opt-out tools where
        available for interest-based advertising.
      </p>

      <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3">5. Updates</h2>
      <p className="text-sm leading-relaxed mb-4">
        We may update this Cookie Policy when our practices change. The &quot;Last updated&quot; date at the top of this
        page will reflect the latest version.
      </p>

      <h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3">6. Contact</h2>
      <p className="text-sm leading-relaxed">
        Questions:{' '}
        <a href="mailto:support@buydrop.com" className="text-green-700 font-medium hover:underline">
          support@buydrop.com
        </a>
        .
      </p>
    </LegalPageLayout>
  );
};

export default CookiePolicy;
